import { useLayoutEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { loadGoogleScript } from "./loadGoogleScript";
import googleConfig from "./googleConfig";
import styles from "./index.css";
import { GOOGLE_ADVERT_LOADED } from "../../../../../../../../../client/state/modules/analytics/reducer/constants";

const GoogleAdvert = ({ savedItems, adPosition }) => {
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();
  const { adId } = googleConfig;

  const handleGoogleLoad = useCallback(async () => {
    dispatch({
      type: GOOGLE_ADVERT_LOADED
    });
  }, [dispatch]);

  useLayoutEffect(() => {
    loadGoogleScript(googleConfig, handleGoogleLoad);
    setLoaded(true);

    return () => {
      setLoaded(false);
    };
  }, [savedItems.length, adPosition, loadGoogleScript]);

  // Having discussed this with the Accessibility team.
  // We need to ensure that the Google Adverts are properly announced to screen readers.
  // This is done via the Google Tag Manager where the alt text and correct aria are set for each advert.

  if (!loaded) return null;

  return (
    <div
      data-testid="google-advert"
      className={styles.googleAdvert}
      id={adId}
    />
  );
};

GoogleAdvert.propTypes = {
  adPosition: PropTypes.number.isRequired,
  savedItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      variants: PropTypes.array
    }).isRequired
  )
};

export default GoogleAdvert;
